import Colors from "../../core/Colors";
import { ComponentF } from "../ui";
export const GlyphBar: ComponentF<{
  current: number;
  max: number;
  reverse: boolean;
  full: string;
  empty: string;
  emptyColor?: string;
  fullColor?: string;
}> = (
  C,
  props = {
    current: 0,
    max: 0,
    reverse: false,
    full: "#",
    empty: " ",
  }
) => {
  let l = 0;
  for (; l < props.current; l++) {
    C.display.draw(
      props.reverse ? C.bounds.x + C.bounds.w - 1 - l : l + C.bounds.x,
      C.bounds.y,
      props.full,
      props.fullColor || Colors.EGGSHELL,
      null
    );
  }
  for (; l < props.max; l++) {
    C.display.draw(
      props.reverse ? C.bounds.x + C.bounds.w - 1 - l : l + C.bounds.x,
      C.bounds.y,
      props.empty,
      props.emptyColor || Colors.GRAY_3,
      null
    );
  }
};
